import React, { useEffect } from "react";
import { X, CircleAlert } from "lucide-react";
import "./ValidationResultsModal.scss";

const ValidationResultsModal = ({
  open,
  title = "Validation Results",
  totalErrors = 0,
  items = [],
  onClose,
  onDownloadErrorReport,
  onTryAgain,
  showDownloadButton = false,
}) => {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && open && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="vr-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="vr-title"
    >
      <div className="vr-modal">
        <button className="vr-close" aria-label="Close" onClick={onClose}>
          <X size={18} />
        </button>
        <div className="vr-header">
          <h3 id="vr-title">{title}</h3>
        </div>
        <div className="vr-body">
          <div className={`vr-banner ${totalErrors === 0 || items.length === 0 ? 'vr-banner-info' : ''}`}>
            <span className="vr-dot" />
            <div>
              <div className="vr-banner-title">
                {totalErrors === 0 || items.length === 0 ? 'No Errors Found' : 'Upload Failed'}
              </div>
              <div className="vr-banner-sub">
                {totalErrors === 0 || items.length === 0
                  ? 'No error logs found for this upload'
                  : `${totalErrors} error${totalErrors !== 1 ? 's' : ''} found in your file`
                }
              </div>
            </div>
          </div>

          <div className="vr-errors">
            {items.map((e) => (
              <div className="vr-error" key={e.id}>
                <CircleAlert size={16} />
                <div>
                  <div className="vr-error-msg">{e.message}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="vr-footer">
          {showDownloadButton && onDownloadErrorReport && (
            <button className="vr-btn vr-btn--secondary" onClick={onDownloadErrorReport}>
              Download Error Report
            </button>
          )}
          <button className="vr-btn vr-btn--primary" onClick={onTryAgain}>
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default ValidationResultsModal;
